import CategoriesScreenV2 from 'features/rewards/screens/Categories/CategoriesScreenV2';
import React from 'react';

export default function Page() {
  return <CategoriesScreenV2 />;
}
